let decoder: HTMLTextAreaElement | null = null

/**
 * Decode HTML entities in CMS/API text (e.g. "&amp;" → "&").
 * WordPress returns strings HTML-encoded; React renders them verbatim.
 * Reading the textarea's .value decodes as text, so no markup is executed.
 */
export function decodeEntities (input: string): string {
	if (!input || !input.includes('&')) return input
	decoder ??= document.createElement('textarea')
	decoder.innerHTML = input
	return decoder.value
}

// HTML fields (rendered via dangerouslySetInnerHTML) and server round-trip identifiers must stay encoded.
const SKIP_KEYS = new Set([
	'applyInterstitialContent',
	'value',
	'slug',
	'cssClasses',
	'sightmap_filter'
])

/**
 * Decode every string in a JSON-like structure in place and return it.
 * Applied once where CMS data enters the app (config, initial data, REST).
 */
export function decodeEntitiesDeep<T> (data: T): T {
	if (Array.isArray(data)) {
		for (let i = 0; i < data.length; i++) {
			const item = data[i]
			data[i] = typeof item === 'string' ? decodeEntities(item) : decodeEntitiesDeep(item)
		}
	} else if (data !== null && typeof data === 'object') {
		const record = data as Record<string, unknown>
		for (const key of Object.keys(record)) {
			if (SKIP_KEYS.has(key)) continue
			const item = record[key]
			// Only write back strings; reassigning objects under a "__proto__" key would swap the prototype.
			if (typeof item === 'string') record[key] = decodeEntities(item)
			else decodeEntitiesDeep(item)
		}
	}
	return data
}
